module.exports = __webpack_public_path__ + "img/fig06.269dce3d.jpg";